import { inject, InjectionToken } from "@angular/core";
import { SideNavService } from "@app/shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";

/** Registers the Revenue Management menu items. */
export const REVENUE_MANAGEMENT_SIDENAV_LINKS = new InjectionToken<void>("REVENUE_MANAGEMENT_SIDENAV_LINKS", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("revenue-management", [
      {
        id: "priceLists",
        label: "REVENUE_MANAGEMENT.ITEMS.PRICE_LISTS",
        icon: "money",
        routerLink: "/revenue-management/price-lists",
        permissions: COMMON_GUARD_OPTIONS.PRICE_LIST.VIEW.permissions,
      },
      {
        id: "reservationSources",
        label: "REVENUE_MANAGEMENT.ITEMS.RESERVATION_SOURCES",
        icon: "tree-structure",
        routerLink: "/revenue-management/reservation-sources",
        permissions: COMMON_GUARD_OPTIONS.RESERVATION_SOURCE.VIEW.permissions,
      },
      {
        id: "configuration",
        label: "REVENUE_MANAGEMENT.ITEMS.CONFIGURATION",
        icon: "configuration",
        permissions: [
          ...COMMON_GUARD_OPTIONS.REVENUE_GENERAL_SETTINGS.VIEW.permissions,
          ...COMMON_GUARD_OPTIONS.RESERVATION_SOURCE_TYPE.VIEW.permissions,
          ...COMMON_GUARD_OPTIONS.RESERVATION_SOURCE_PARENT.VIEW.permissions,
        ],
        expanded: true,
        items: [
          {
            id: "systemConfiguration",
            label: "REVENUE_MANAGEMENT.ITEMS.SYSTEM_CONFIGURATION",
            routerLink: "/revenue-management/system-configuration",
            permissions: COMMON_GUARD_OPTIONS.REVENUE_GENERAL_SETTINGS.VIEW.permissions,
          },
          {
            id: "reservationSourceTypes",
            label: "REVENUE_MANAGEMENT.ITEMS.RESERVATION_SOURCE_TYPES",
            routerLink: "/revenue-management/reservation-source-types",
            permissions: COMMON_GUARD_OPTIONS.RESERVATION_SOURCE_TYPE.VIEW.permissions,
          },
          {
            id: "reservationSourceParents",
            label: "REVENUE_MANAGEMENT.ITEMS.RESERVATION_SOURCE_PARENTS",
            routerLink: "/revenue-management/reservation-source-parents",
            permissions: COMMON_GUARD_OPTIONS.RESERVATION_SOURCE_PARENT.VIEW.permissions,
          },
        ],
      },
    ]);
  },
});
